import { create } from 'zustand'

export type AuthStep = 'email' | 'code' | 'offer-telegram' | 'name'

interface AuthFlowState {
  step: AuthStep
  email: string
  nextResendAt: string | null
  expiredAt: string | null
  attemptsLeft: number | null
  isLocked: boolean
  error: string | null
  debugCode: string | null

  setStep: (step: AuthStep) => void
  setEmail: (email: string) => void
  setCooldown: (next_resend: string, expired_at: string) => void
  setError: (error: string | null) => void
  setAttemptsLeft: (n: number | null) => void
  setLocked: (v: boolean) => void
  setDebugCode: (c: string | null) => void
  reset: () => void
}

const initial = {
  step: 'email' as AuthStep,
  email: '',
  nextResendAt: null,
  expiredAt: null,
  attemptsLeft: null,
  isLocked: false,
  error: null,
  debugCode: null
}

/**
 * Zustand-стор эфемерного состояния флоу web-авторизации.
 * Без persist — состояние живёт только пока юзер на /auth.
 * @returns Стор шагов/таймеров/ошибок флоу авторизации
 */
export const useAuthFlowStore = create<AuthFlowState>((set) => ({
  ...initial,
  setStep: (step) => set({ step, error: null }),
  setEmail: (email) => set({ email }),
  setCooldown: (next_resend, expired_at) => set({ nextResendAt: next_resend, expiredAt: expired_at }),
  setError: (error) => set({ error }),
  setAttemptsLeft: (n) => set({ attemptsLeft: n }),
  setLocked: (v) => set({ isLocked: v }),
  setDebugCode: (c) => set({ debugCode: c }),
  reset: () => set({ ...initial })
}))
